// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dLS7HRHHu3gMNYf5tJgj{display:-webkit-box;display:-ms-flexbox;display:flex}html[dir] .NpmZUu_mSEjdUb6VvkNH{background:var(--white)}.NpmZUu_mSEjdUb6VvkNH.m2FA7msy68TL5ZnbjKi0,.NpmZUu_mSEjdUb6VvkNH.QK2dMnkxBsgXeKxfJzs2{height:36px}.NpmZUu_mSEjdUb6VvkNH.RcbLMw6b4ScONRqIUqbh{height:32px}html[dir] .EiZMz1yzZUZJA2h1j3xb.m2FA7msy68TL5ZnbjKi0{padding-top:8px}html[dir] .EiZMz1yzZUZJA2h1j3xb.RcbLMw6b4ScONRqIUqbh,html[dir] .EiZMz1yzZUZJA2h1j3xb.QK2dMnkxBsgXeKxfJzs2{padding-top:6px}html[dir] .qkxBtLqlGA4hF7e6d942.m2FA7msy68TL5ZnbjKi0{padding-top:4px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shimmerRow": "dLS7HRHHu3gMNYf5tJgj",
	"mailListShimmerContainer": "NpmZUu_mSEjdUb6VvkNH",
	"full": "m2FA7msy68TL5ZnbjKi0",
	"medium": "QK2dMnkxBsgXeKxfJzs2",
	"compact": "RcbLMw6b4ScONRqIUqbh",
	"paddingFirstMessage": "EiZMz1yzZUZJA2h1j3xb",
	"paddingMessage": "qkxBtLqlGA4hF7e6d942"
};
module.exports = ___CSS_LOADER_EXPORT___;
